import {createElement, PropTypes} from 'rlink-react';

import IntroPanelSpaceMarines from './IntroPanelSpaceMarines';
import IntroPanelEldar from './IntroPanelEldar';
import IntroPanelOrks from './IntroPanelOrks';

export default function IntroPanel ({faction, css}) {
  switch (faction) {
    case 'spacemarines':
      return <IntroPanelSpaceMarines css={css} />;
    case 'eldar':
      return <IntroPanelEldar css={css} />;
    case 'orks':
      return <IntroPanelOrks css={css} />;
    default:
      return <div />;
  }
}

IntroPanel.propTypes = {
  faction: PropTypes.string,
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/IntroPanel.jsx